import { useEffect } from "react";

import { isNullish } from "@theorgchartdev/storybook";
import { enumObjectTypes } from "@coreapp/constants";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import type { QPlanManager } from "@coreapp/CoreApp/QPlanManager";

type RecordReference = {
  refId: string;
  objType: ValueOf<typeof enumObjectTypes>;
};

export const usePlanningCache = (records: RecordReference[]) => {
  const planMgrContext = usePlanManagerContext();
  const planMgr: Nullish<QPlanManager> = planMgrContext?.planManager.state;

  // This effect will trigger a request in the scenario
  // that the cache doesn't have the record
  useEffect(() => {
    if (isNullish(planMgr)) {
      return;
    }

    const { recordIDs, positionIDs } = records.reduce(
      (acc, { refId, objType }) => {
        if (planMgr.HasCacheEntry(objType, refId)) {
          return acc;
        }

        if (objType === enumObjectTypes.holder) {
          acc.recordIDs.push(refId);
        } else if (objType === enumObjectTypes.position) {
          acc.positionIDs.push(refId);
        }

        return acc;
      },
      { recordIDs: [] as string[], positionIDs: [] as string[] }
    );

    if (recordIDs.length === 0 && positionIDs.length === 0) {
      return;
    }

    planMgr.LoadRecords({ recordIDs, positionIDs }, () => {
      planMgr.PopulateCacheFromOverrides(positionIDs, recordIDs);
    });
  }, [planMgr, JSON.stringify(records)]);
};
